import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // optional background image

const ImportsQualityMonitoringScheme = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Imports Quality Monitoring Scheme</h1>
          <p className="subtitle">
            The Imports Quality Monitoring Scheme (IQMS) ensures imported products meet national quality and safety standards.
          </p>
          <p className="subtitle">
            This protects consumers, the environment, and the national economy while ensuring a level playing field for local products.
          </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
        

        <p className="paragraph">
          The Imports Quality Monitoring Scheme (IQMS) was established in 1993 with the objective of protecting the public/consumer by ensuring that imported products are monitored for fitness of use (quality) and that they do not cause safety or health hazards to humans, animals, or damage the environment. The scheme also provides a level playing field for similar products made in Malawi. Import batch certificates are issued to complying consignments, while non-complying consignments are denied entry based on the critical nature of the non-conformity.
        </p>

        
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .what-section { padding: 50px 80px; }
        .section-title {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }

        .paragraph {
          font-size: 1rem;
          line-height: 1.7;
          margin: 15px 0;
          text-align: left;
        }

        .centered-text { text-align: center; }

        a {
          color: #ff6600;
          font-weight: bold;
          text-decoration: none;
        }

        a:hover { text-decoration: underline; }

        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>

    </div>
  );
};

export default ImportsQualityMonitoringScheme;
